<template>
  <div class="main">
    <!-- 个人资料 -->
    <div class="personal-data">
      <!-- 头像部分 -->
      <div class="herder-box">
        <div class="herder-left">
          <div class="img-box">
            <img
              class="head"
              v-if="$store.state.userInfo.avatarUrl"
              :src="`${$Url}${$store.state.userInfo.avatarUrl}`"
            />
            <img class="head" v-else src="@/assets/image/module/head.png" />

            <img
              class="v"
              :src="require(`@/assets/image/homepage/v${this.grade}.png`)"
            />
          </div>
          <div class="info-box">
            <div class="name">{{ $store.state.userInfo.userName }}</div>
            <div class="info">
              <div class="code">邀请码: {{ recommendedCode }}</div>
              <div class="copy" @click="copyText">[复制]</div>
            </div>
          </div>
        </div>
        <div class="herder-right" @click="goUrl('/mobile/personalData')">
          完善资料
        </div>
      </div>
      <!-- 账户余额 -->
      <div class="finance-box">
        <div class="finance-left">
          <div class="number-box">{{ userInfo.balance }}<span>金币</span></div>
          <div class="name">账户余额</div>
        </div>
        <div class="line"></div>
        <div class="finance-right">
          <div class="number-box">{{ userInfo.credit }}</div>
          <div class="name">信用值</div>
        </div>
      </div>
      <!-- 信用值 -->
      <div class="credit-box">
        <div class="herder-icon"></div>
        <div class="title-box" v-if="this.grade < 6">
          提等级<span>距离下一个等级仅需{{ differenceNuber }}信用值</span>
        </div>

        <div class="title-box" v-else>已满级<span>当前等级v6</span></div>
        <div class="progress-box">
          <van-progress
            color="#8846FF"
            :percentage="percentage2"
            :show-pivot="false"
          />
          <div :class="['div-box div-box1', { 'div-box-active': credit >= 0 }]">
            <div class="number">0</div>
            <div class="star"></div>
            <div class="text">v1</div>
          </div>
          <div
            :class="['div-box div-box2', { 'div-box-active': credit >= 61 }]"
          >
            <div class="number">61</div>
            <div class="star"></div>
            <div class="text">v2</div>
          </div>
          <div
            :class="['div-box div-box3', { 'div-box-active': credit >= 101 }]"
          >
            <div class="number">101</div>
            <div class="star"></div>
            <div class="text">v3</div>
          </div>
          <div
            :class="['div-box div-box4', { 'div-box-active': credit >= 201 }]"
          >
            <div class="number">201</div>
            <div class="star"></div>
            <div class="text">v4</div>
          </div>
          <div
            :class="['div-box div-box5', { 'div-box-active': credit >= 501 }]"
          >
            <div class="number">501</div>
            <div class="star"></div>
            <div class="text">v5</div>
          </div>
          <div
            :class="['div-box div-box6', { 'div-box-active': credit >= 801 }]"
          >
            <div class="number">801</div>
            <div class="star"></div>
            <div class="text">v6</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 卡片 -->
    <div class="my-content">
      <div class="title">常用功能</div>
      <div class="list">
        <div
          class="list-item"
          v-for="(item, index) in list1"
          @click="goUrl(item.path)"
          :key="index"
        >
          <img class="cy" :src="item.url" />
          <div class="name">{{ item.name }}</div>
        </div>
      </div>

      <div class="list">
        <div
          class="list-item"
          v-for="(item, index) in list11"
          @click="goUrl(item.path)"
          :key="index"
        >
          <div class="cy-box"><img class="cy-img" :src="item.url" /></div>
          <div class="name">{{ item.name }}</div>
        </div>
      </div>
      <div class="title title-top">其他服务</div>
      <div class="list">
        <div
          class="list-item"
          @click="goUrl(item.path)"
          v-for="(item, index) in list2"
          :key="index"
        >
          <img class="qt" :src="item.url" />
          <div class="name">{{ item.name }}</div>
        </div>
      </div>
    </div>
    <Tabbar :active="4"></Tabbar>
  </div>
</template>

<script>
import Tabbar from "@/components/tabbar.vue";
import {
  getAccount,
  getWeChatAuthWechatUrl,
} from "@/api/mobile";
import { copyText, generateUUID } from "@/utils/replace";
export default {
  data() {
    return {
      active: 1,
      list1: [
        {
          name: "兑换记录",
          url: require("@/assets/mobile/image/my/cygn1.png"),
          path: "/mobile/exchangeRecords",
        },
        {
          name: "信用明细",
          url: require("@/assets/mobile/image/my/cygn2.png"),
          path: "/mobile/creditDetails",
        },
        {
          name: "任务记录",
          url: require("@/assets/mobile/image/my/cygn3.png"),
          path: "/mobile/taskRecord",
        },
        {
          name: "问卷攻略",
          url: require("@/assets/mobile/image/my/cygn4.png"),
        },
      ],
      list11: [
        {
          name: "我的消息",
          url: require("@/assets/mobile/image/my/cygn5.png"),
          path: "/mobile/myMessages",
        },
      ],
      list2: [
        {
          name: "账户设置",
          url: require("@/assets/mobile/image/my/qtfw1.png"),
          path: "/mobile/accountSettings",
        },
        {
          name: "关于我们",
          url: require("@/assets/mobile/image/my/qtfw2.png"),
          path: "/mobile/aboutUs",
        },
        {
          name: "常见问题",
          url: require("@/assets/mobile/image/my/qtfw3.png"),
          path: "/mobile/problem",
        },
        {
          name: "隐私条款",
          url: require("@/assets/mobile/image/my/qtfw4.png"),
          path: "/mobile/privacy",
        },
      ],
      userInfo: {},

      grade: 1,
      credit: 0,
      recommendedCode: "",
      percentage2: 0,
      differenceNuber: 0,

      weixinFlag: false,
    };
  },
  components: { Tabbar },
  computed: {
    percentage() {
      return 100;
    },
  },
  methods: {
    goUrl(path) {
      this.$router.push(path);
    },
    getGrade() {
      if (this.userInfo.credit <= 60) {
        return 1;
      }
      if (61 <= this.userInfo.credit && this.userInfo.credit <= 100) {
        return 2;
      }
      if (101 <= this.userInfo.credit && this.userInfo.credit <= 200) {
        return 3;
      }
      if (201 <= this.userInfo.credit && this.userInfo.credit <= 500) {
        return 4;
      }
      if (501 <= this.userInfo.credit && this.userInfo.credit <= 800) {
        return 5;
      }
      if (801 <= this.userInfo.credit && this.userInfo.credit <= 1000) {
        return 6;
      }
      return 1;
    },
    //长形信用值
    changePercentage2() {
      this.percentage2 = (this.userInfo.credit * 100) / 801;
    },
    copyText() {
      copyText(this.recommendedCode).then((res) => {
        if (res === "复制成功") {
          this.$toast("复制成功");
        } else {
          this.$toast("复制失败");
        }
      });
    },
  },
  async created() {
    //微信自动登录
    if (this.$route.query.from && this.$route.query.from === "wechat") {
      this.weixinFlag = true;
      let state = generateUUID();
      let redirectUrl =
        "https://www.aidajuan.com/mobile/landingPage?url=" + "/mobile/my";
      await getWeChatAuthWechatUrl({
        redirectUrl,
        state,
      }).then((res) => {
        if (res.code === 200) {
          window.location.href = res.data;
        }
      });
    }
    if (this.weixinFlag) {
      return;
    }

    await getAccount().then((res) => {
      if (res.code === 200) {
        this.userInfo = res.data;
        this.$store.commit("changeUserInfo", this.userInfo);
        localStorage.setItem("userInfo", JSON.stringify(res.data));
      }
    });

    this.credit = this.userInfo.credit;
    this.recommendedCode = this.userInfo.recommendedCode;
    this.grade = this.getGrade();
    this.changePercentage2();

    switch (this.grade) {
      case 1:
        this.gradeName = "一般";
        this.frontNumber = 0;
        this.behindNumer = 60;
        this.incomePromote = 0;
        this.differenceNuber = 61 - this.userInfo.credit;
        break;
      case 2:
        this.gradeName = "中等";
        this.frontNumber = 61;
        this.behindNumer = 100;
        this.incomePromote = 5;
        this.differenceNuber = 101 - this.userInfo.credit;
        break;
      case 3:
        this.gradeName = "良好";
        this.frontNumber = 101;
        this.behindNumer = 200;
        this.incomePromote = 10;
        this.differenceNuber = 201 - this.userInfo.credit;
        break;
      case 4:
        this.gradeName = "优秀";
        this.frontNumber = 201;
        this.behindNumer = 500;
        this.incomePromote = 15;
        this.differenceNuber = 501 - this.userInfo.credit;
        break;
      case 5:
        this.gradeName = "钻石";
        this.frontNumber = 501;
        this.behindNumer = 800;
        this.incomePromote = 20;
        this.differenceNuber = 801 - this.userInfo.credit;
        break;
      case 6:
        this.gradeName = "王者";
        this.frontNumber = 801;
        this.behindNumer = 1000;
        this.incomePromote = 40;
        break;
    }
  },
};
</script>

<style lang="scss" scoped>
.main {
  background-color: #f8f8f8;
  padding-bottom: 50px;
  min-height: calc(100vh - 50px);

  //个人资料
  .personal-data {
    background-color: #f8f8f8;
    background-image: url("../../assets/mobile/image/common/shadow.png");
    background-size: cover;
    background-position: 100% 100%;
    background-repeat: no-repeat;
    padding: 10px 0;
    width: 100%;
    // 头像部分
    .herder-box {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .herder-left {
        display: flex;
        margin-left: 15px;
        align-items: center;
        .img-box {
          position: relative;
          width: 56px;
          height: 56px;
          border-radius: 28px;
          // margin-left: 11px;
          .head {
            width: 100%;
            height: 100%;
            border-radius: 28px;
          }
          .v {
            position: absolute;
            width: 16px;
            height: 16px;
            bottom: 0;
            right: 0;
          }
        }
        .info-box {
          display: flex;
          flex-direction: column;
          margin-left: 11px;
          .name {
            font-size: 16px;
            color: #232323;
            font-weight: bolder;
          }
          .info {
            display: flex;
            margin-top: 8px;
            .code {
              color: #232323;
              font-size: 14px;
            }
            .copy {
              color: #ff4d46;
              font-size: 14px;
              margin-left: 17px;
            }
          }
        }
      }
      .herder-right {
        width: 77px;
        height: 23px;
        background: rgba(136, 70, 255, 0.05);
        border-radius: 13px 0px 0px 13px;
        color: #8846ff;
        font-size: 12px;
        text-align: center;
        line-height: 23px;
      }
    }
    // 账户余额
    .finance-box {
      width: calc(100% - 30px);
      margin-left: 15px;
      margin-top: 17px;
      border-radius: 10px;
      height: 75px;
      background: linear-gradient(151deg, #b890ff 0%, #9255ff 100%);
      display: flex;
      align-items: center;
      color: #fff;
      .finance-left {
        width: calc(50% - 0.5px);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }
      .line {
        width: 1px;
        height: 39px;
        background-color: #bd98ff;
      }
      .finance-right {
        width: calc(50% - 0.5px);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }
      .number-box {
        font-size: 28px;
        font-weight: bolder;
        display: flex;
        align-items: center;
        span {
          font-size: 12px;
          font-weight: normal;
          margin-left: 5px;
        }
      }
      .name {
        font-size: 12px;
        margin-top: 4px;
      }
    }
    //信用值
    .credit-box {
      width: calc(100% - 30px);
      height: 146px;
      background: #ffffff;
      border-radius: 10px 10px 10px 10px;
      margin-left: 15px;
      margin-top: 10px;
      position: relative;
      .herder-icon {
        width: 28px;
        height: 28px;
        background: linear-gradient(
          157deg,
          rgba(136, 70, 255, 0) 0%,
          rgba(136, 70, 255, 0.61) 100%
        );
        position: absolute;
        top: 9px;
        left: 10px;
        border-radius: 14px;
        z-index: 1;
      }
      .title-box {
        position: relative;
        z-index: 2;
        font-size: 16px;
        color: #232323;
        font-weight: bolder;
        padding-top: 19px;
        margin-left: 22px;
        span {
          font-size: 14px;
          font-weight: normal;
          margin-left: 17px;
        }
      }
      .progress-box {
        margin-top: 15px;
        height: 80px;
        margin-left: 21px;
        width: calc(100% - 42px);
        position: relative;
        .van-progress {
          position: absolute;
          width: 100%;
          top: 30px;
        }
        .div-box {
          position: absolute;
          top: 0px;
          left: 0;
          width: 22px;
          display: flex;
          flex-direction: column;
          align-items: center;
          cursor: pointer;
          .number {
            color: #232323;
            font-size: 12px;
          }
          .text {
            color: #232323;
            font-size: 12px;
            margin-top: 15px;
          }
          .star {
            border: 2px solid #fff;
            border-radius: 10px;
            background-color: #ededed;
            width: 8px;
            height: 8px;
            margin-top: 10px;
          }
        }
        .div-box-active {
          .star {
            background-color: #8846ff;
          }
        }
        .div-box1 {
          left: -5.6px;
        }
        .div-box2 {
          left: calc(7.615% - 5.6px);
        }
        .div-box3 {
          left: calc(12.615% - 5.6px);
        }
        .div-box4 {
          left: calc(25.115% - 5.6px);
        }
        .div-box5 {
          left: calc(62.615% - 5.6px);
        }
        .div-box6 {
          left: calc(100% - 5.6px);
        }
      }
    }
  }

  //卡片
  .my-content {
    width: calc(100% - 30px);
    height: 353px;
    background: #ffffff;
    border-radius: 10px 10px 10px 10px;
    margin-left: 15px;
    margin-bottom: 10px;
    padding: 15px;
    box-sizing: border-box;
    .title {
      font-size: 16px;
      color: #232323;
      font-weight: bolder;
    }
    .title-top {
      margin-top: 30px;
    }
    .list {
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
      .list-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        .cy {
          width: 42px;
          height: 42px;
        }
        .cy-box {
          width: 42px;
          height: 42px;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: #ebfaf6;
          border-radius: 21px;
          .cy-img {
            width: 30px;
            height: 30px;
          }
        }
        .qt {
          width: 26px;
          height: 26px;
        }
        .name {
          font-size: 14px;
          margin-top: 8px;
          color: #232323;
        }
      }
    }
  }
}
</style>